import * as Sentry from "@sentry/react";

import type { SaleStatus } from "@meditect/medibase-api-client";

type SaleArraysMaybeMissing = {
  id: string;
  status?: SaleStatus;
  records?: unknown[];
  payments?: unknown[];
  vouchers?: unknown[];
};

const SALE_ARRAY_KEYS = ["records", "payments", "vouchers"] as const;

const alreadyReported = new Set<string>();

// La réponse allégée du POST /sales doit être fusionnée avec les records/payments locaux avant
// toute écriture (LGO-1169). Une vente sans ses tableaux qui atteint un writer = fusion contournée
// quelque part : on capture la stack pour nommer le chemin fautif, plutôt que de blinder chaque
// lecteur après coup (LGO-1214).
export const reportSlimSaleWrite = (origin: string, sale: SaleArraysMaybeMissing): void => {
  const missing = SALE_ARRAY_KEYS.filter((key) => sale[key] == null);
  if (missing.length === 0) {
    return;
  }

  const fingerprint = `${origin}:${sale.id}`;
  if (alreadyReported.has(fingerprint)) {
    return;
  }
  alreadyReported.add(fingerprint);

  Sentry.captureException(new Error(`Vente allégée écrite via ${origin} (${missing.join(", ")} absents)`), {
    extra: { missing, saleId: sale.id, saleStatus: sale.status },
    tags: { failure: "slim-sale-write", origin },
  });
};
